import { MovieDBType } from "../types/Movie";

const API_KEY = "api_key=" + process.env.REACT_APP_MOVIE_DB_API_KEY;
const API_BASE_URL = "https://api.themoviedb.org/3/";
const IMAGE_BASE_URL = "https://image.tmdb.org/t/p/w500";

const POSTER_MEMO_MAP = new Map();

async function getData(url: string, hasQueries: boolean = false) {
  const response = await fetch(url + (hasQueries ? "&" : "?") + API_KEY, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.json();
}

export const getMoviesMatchingTitle = (title: string) => {
  return getData(API_BASE_URL + "search/movie?query=" + title, true).then(
    (data) => {
      return data.results;
    }
  );
};

export const getPosterForMovie = async (movie: MovieDBType) => {
  if (POSTER_MEMO_MAP.get(movie.id)) {
    return POSTER_MEMO_MAP.get(movie.id);
  } else {
    const url = IMAGE_BASE_URL + movie.poster_path;
    const response = await fetch(url + "?" + API_KEY, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    POSTER_MEMO_MAP.set(movie.id, response.url);
    return response.url;
  }
};
